import { memo } from 'react';
import cn from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { ContentDispatchActions } from 'src/redux/actions';
import { isLargeFontSize } from 'src/selectors/content';
import { Button, Element, Icon } from 'src/components';
import styles from './style.module.scss';

interface IProps {
    className?: string;
    contentId: number;
}

const ChangeSizeButton = ({ className, contentId }: IProps) => {
    const isLargeFont = useSelector(isLargeFontSize);
    const dispatch = useDispatch();

    const handleClick = () => {
        dispatch(ContentDispatchActions.toggleFontSize());
    };

    return (
        <Button title="Cỡ chữ">
            <Icon icon="font-size"></Icon>
            <span>Cỡ chữ bài viết</span>
            <Element
                className={cn(styles['btn-switch'], {
                    [styles['is-active']]: isLargeFont,
                })}
                onClick={handleClick}
            ></Element>
        </Button>
    );
};

export default memo(ChangeSizeButton);
